import { useState } from "react";
import { NavLink } from "react-router-dom";
import hamburger from "../assets/hamburger.svg";
import upRightArrow from "../assets/up-right-arrow-white.svg";

export default function MobilMenuDrawer() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  return (
    <div className="mobileHamburgerIcon">
      {drawerOpen ? (
        <button
          className="btn-close closeIcon"
          onClick={() => {
            setIsClosing(true);
          }}
        ></button>
      ) : (
        <div
          onClick={() => {
            setDrawerOpen(true);
            setIsClosing(false);
          }}
        >
          <img src={hamburger} alt="hamburger" />
        </div>
      )}

      {drawerOpen ? (
        <div
          className={`mobileContainerForDrawer ${isClosing ? "mobileDrawer-exit" : "mobileDrawer-enter"
            }`}
          onAnimationEnd={() => isClosing && setDrawerOpen(false)}
        >
          <div className="mb-2 d-flex align-items-center mobileMenuLabels">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              aria-current="page"
              to="/services"
              onClick={() => setIsClosing(true)}
            >
              Services
            </NavLink>

            <NavLink
              onClick={() => setIsClosing(true)}
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              to="/media"
            >
              Media
            </NavLink>

            <NavLink
              onClick={() => setIsClosing(true)}
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              to="/faqs"
            >
              FAQs
            </NavLink>

            <NavLink
              onClick={() => setIsClosing(true)}
              className={({ isActive }) =>
                isActive
                  ? "button-text nav-button active"
                  : "button-text nav-button"
              }
              to="/contact"
            >
              Contact
            </NavLink>
          </div>

          <button
            className="btn btn-primary"
            onClick={() => {
              setIsClosing(true);
              window.open(
                "https://connect.regulatecpg.com/regulate-book-a-demo",
                "_blank"
              );
            }}
          >
            Book Demo <img src={upRightArrow} alt="Arrow" />
          </button>
        </div>
      ) : null}
    </div>
  );
}
